// ============================================================================
// Grupos colapsables del sidebar (2026-08-18).
//
// Existen porque el admin dejó de cambiarse de perfil para trabajar: ahora ve
// TODAS las pantallas del sistema y una lista plana de ~15 renglones no se
// navega. La agrupación es POR FUNCIÓN ("qué quiero hacer"), no por perfil.
//
// El orden de este objeto ES el orden en que se pintan los grupos. Las rutas
// sin `group` salen sueltas ARRIBA de todos los grupos.
// ============================================================================

export enum SidebarGroup {
    Operation = 'operation',
    Analytics = 'analytics',
    Catalog = 'catalog',
    Inventory = 'inventory',
    Settings = 'settings'
}

interface SidebarGroupConfig {
    label: string;
    /** Grupos que arrancan abiertos la PRIMERA vez (después manda el localStorage). */
    defaultOpen: boolean;
}

export const SIDEBAR_GROUPS: Record<SidebarGroup, SidebarGroupConfig> = {
    [SidebarGroup.Operation]: { label: 'Operación', defaultOpen: true },
    [SidebarGroup.Analytics]: { label: 'Análisis', defaultOpen: true },
    [SidebarGroup.Catalog]: { label: 'Catálogo y precios', defaultOpen: false },
    [SidebarGroup.Inventory]: { label: 'Inventario', defaultOpen: false },
    [SidebarGroup.Settings]: { label: 'Configuración', defaultOpen: false }
};

/** Orden de pintado, derivado de las llaves de SIDEBAR_GROUPS. */
export const SIDEBAR_GROUP_ORDER = Object.keys(SIDEBAR_GROUPS) as SidebarGroup[];
